import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "searchbar-wrapper" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"margin-bottom":"5px"},
    onKeydown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_icon, { icon: _ctx.icon }, null, 8, ["icon"]),
    _createTextVNode(" " + _toDisplayString(_ctx.title) + " ", 1),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        type: "text",
        class: "searchbar-input",
        autocomplete: "off",
        placeholder: _ctx.isFocused ? '' : _ctx.placeholder,
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = true)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocused = false)),
        onInput: _withModifiers(($event: any) => (false), ["prevent","stop"])
      }, null, 40, _hoisted_2), [
        [_vModelText, _ctx.searchText]
      ])
    ]),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected) = $event)),
      class: "ddl"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: `${option.id ? option.id : option}`,
          value: option
        }, _toDisplayString(option.name ? option.name : option), 9, _hoisted_3))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.selected]
    ])
  ], 32))
}